import React from 'react';
import { useTranslation } from 'react-i18next';
import LogoEmblem from 'assets/images/logo/main_logo-emblem.svg';
import LogoLarge from 'assets/images/logo/main_logo.svg';
import './Logo.css';

export const Logo = () => {
    const { t } = useTranslation();

    return (
        <div className="">
            <img className="mainLogo" src={LogoLarge} alt={t('login.title')}/>
            <img className="mainLogo-sm" src={LogoEmblem} alt={t('login.title')}/>
        </div>
    );
};
